import {BaseSpringServiceCB} from '@aiknow-srl/aik-ngx-http';
import {UserOPEEnum} from "./UserOPEEnum";

/**
 * I inner class
 */
class I {

}

/**
 * O inner class
 */

class O {
  pushNotificationUserToken!: string;
}


/**
 * put reseller class
 */

export class RefreshPushNotificationTokenCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor() {
    super(UserOPEEnum.RefreshPushNotificationToken);
    this.i = new I();
    this.o = new O();
  }

}
